import React, { CSSProperties} from "react";
import * as styles from "./style.module.css";
import { LinkButtonProps } from "../interface/interface";

const LinkButton:React.FC<LinkButtonProps> = ({ href, style, text, className, onClick }) => (
    <a
      onClick={onClick}
      href={href}
      className={`${styles.btn} ${!!className === true && className}`}
      style={style}
    >
      {text}
    </a>
);


export default LinkButton;
